import cloneDeep from 'lodash.clonedeep'

/**
 * Get all journals which comply to the current active filters
 *
 * @param allJournals
 * @param activeFilterTagUids
 * @param isFilterLogicOr
 * @returns {*}
 */
export const getFilteredAndSearchedJournals = (allJournals, activeFilterTagUids, isFilterLogicOr) => {
    // optimization: if there is no filter active: return all journals
    if (activeFilterTagUids.length === 0) {
        return allJournals
    }

    // filter out all journals which don't comply with the currently selected filters
    return allJournals.filter((journal) => {
        const activeFilterTagUidsArray = Array.from(activeFilterTagUids)

        if (isFilterLogicOr) {
            // check if some active filter (taxonomies) is present in the taxonomies of the journal (we have an "OR" connection between all filters)
            return activeFilterTagUidsArray.some((filter) => journal.taxonomies.includes(filter))
        } else {
            // check if every active filter (taxonomies) is present in the taxonomies of the journal (we have an "AND" connection between all filters)
            return activeFilterTagUidsArray.every((filter) => journal.taxonomies.includes(filter))
        }
    })
}

/**
 * Get all filters that still have journals that could be filtered
 *
 * @param allFilters
 * @param filteredAndSearchedJournals
 * @returns {*}
 */
export const getAvailableFilters = (allFilters, filteredAndSearchedJournals) => {
    // deep clone the allFilters object because we don't want to modify the existing one
    allFilters = cloneDeep(allFilters)

    const availableFilters = allFilters.map((category) => {
        category.tags = category.tags.filter((filterTag) =>
            // if some (any) journal has a tag which matches the filterTag
            filteredAndSearchedJournals.some((journal) => journal.taxonomies.includes(filterTag.uid))
        )

        if (category.name === 'categories') {
            category.tags = category.tags.sort((a, b) => {
                return a.name.localeCompare(b.name)
            })
        }

        return category
    })

    countJournalsInFilters(filteredAndSearchedJournals, availableFilters)

    // remove the category entirely if there are no tags left
    return availableFilters.filter((category) => category.tags.length !== 0)
}

/**
 * Returns available Categories and Tags based on given Journals
 * @param searchedJournals
 * @param activeFilterTagUids
 * @param allFilters
 * @param isFilterLogicOr
 * @returns {{filteredAndSearchedJournals: Object, availableFilters: Object, currentPage: number}}
 */
export const getFilteredItems = (searchedJournals, activeFilterTagUids, allFilters, isFilterLogicOr) => {
    const filteredAndSearchedJournals = getFilteredAndSearchedJournals(
        searchedJournals,
        activeFilterTagUids,
        isFilterLogicOr
    )
    const availableFilters = getAvailableFilters(allFilters, filteredAndSearchedJournals)

    return {
        filteredAndSearchedJournals: () => filteredAndSearchedJournals,
        availableFilters: () => availableFilters,
        currentPage: 0,
    }
}

/**
 * Counts how many Journals each Filter has
 *
 * @param allJournals
 * @param allFilters
 */
export const countJournalsInFilters = (allJournals, allFilters) => {
    allFilters.map((category) => {
        category.tags = category.tags.map((filterTag) => {
            filterTag.count = 0 // reset filter count to 0 before recounting
            allJournals.forEach((journal) => {
                if (journal.taxonomies.includes(filterTag.uid)) {
                    filterTag.count = filterTag.count + 1
                }
            })

            return filterTag
        })

        return category
    })
}
